import client from "./client";

export interface FinchStatus {
  connected: boolean;
  provider_id: string | null;
  products: string[];
  last_synced_at: string | null;
  last_error: string | null;
}

export interface FinchConnectToken {
  connect_url: string;
  state: string;
  redirect_uri: string;
}

export interface FinchSyncSummary {
  pulled: number;
  matched: number;
  unmatched: number;
  missing: number;
  matches: Array<{
    employee_id: string;
    finch_id: string;
    email: string | null;
    first_name: string | null;
    last_name: string | null;
    title: string | null;
    department: string | null;
  }>;
  unmatched_individuals: Array<{
    finch_id: string;
    email: string | null;
    first_name: string | null;
    last_name: string | null;
    title: string | null;
    department: string | null;
  }>;
  missing_employees: Array<{ employee_id: string; email: string | null }>;
}

export async function getFinchStatus(): Promise<FinchStatus> {
  const { data } = await client.get<FinchStatus>("/payroll/finch/status");
  return data;
}

export async function getFinchConnectToken(): Promise<FinchConnectToken> {
  const { data } = await client.post<FinchConnectToken>(
    "/payroll/finch/connect-token",
  );
  return data;
}

export async function exchangeFinchToken(
  publicToken: string,
  state?: string,
): Promise<{ connected: boolean; provider_id: string | null; products: string[] }> {
  const { data } = await client.post("/payroll/finch/exchange", {
    public_token: publicToken,
    state,
  });
  return data;
}

export async function syncFinch(): Promise<FinchSyncSummary> {
  const { data } = await client.post<FinchSyncSummary>("/payroll/finch/sync");
  return data;
}

export async function disconnectFinch(): Promise<void> {
  await client.post("/payroll/finch/disconnect");
}
